import React from "react";
import { PlanBalanceCard } from "./PlanBalanceCard";

export function PlanBalancePage({ history }) {
  return <PlanBalanceCard />;
}
